export default "__VITE_ASSET__79adad98__"